import type from "../../../../constant/type";

const onChangeRemark = (e, dispatch) => {
  let value = e.target.value ? e.target.value : "";
  dispatch({
    type: type.STORE_INVOICE_DATA,
    payload: {
      key: "remark",
      data: {
        value: value,
      },
    },
  });
};

export { onChangeRemark };
